require('./src/assets/scss/init.scss');
require('prismjs/plugins/line-numbers/prism-line-numbers.css');

exports.onClientEntry = () => {};
